import { getErrorAction } from './errorMapper'
import { redirectToError } from './redirectToError'
import { createReducer } from './reducerUtils'
import { mergeMap, map, catchError } from 'rxjs/operators'
import { ofType } from 'redux-observable'
import { of } from 'rxjs'

// Actions
export const BOARD_DEFS_LOAD = 'BOARD_DEFS_LOAD'
export const BOARD_DEFS_LOAD_SUCCESS = 'BOARD_DEFS_LOAD_SUCCESS'
export const BOARD_DEFS_LOAD_FAILURE = 'BOARD_DEFS_LOAD_FAILURE'

// Action Creators
export const boardDefsLoad = () => ({ type: BOARD_DEFS_LOAD })
export const boardDefsLoadSuccess = payload => ({ type: BOARD_DEFS_LOAD_SUCCESS, payload })
export const boardDefsLoadFailure = payload => ({ type: BOARD_DEFS_LOAD_FAILURE, payload, error: true })

// Epics
export const boardDefsLoadEpic = (action$, state$, { vapiClient }) =>
  action$.pipe(
    ofType(BOARD_DEFS_LOAD),
    mergeMap(action =>
      vapiClient.getBoardDefs().pipe(
        map(ajaxResponse => boardDefsLoadSuccess(ajaxResponse.response)),
        catchError(error => of(getErrorAction(error, boardDefsLoadFailure)))
      )
    )
  )

export const boardDefsLoadFailureEpic = (action$, state$) =>
  action$.pipe(
    ofType(BOARD_DEFS_LOAD_FAILURE),
    map(action => redirectToError())
  )

// Reducer
const boardDefsLoadSuccessReducer = (state, boardDefs) =>
  Object.assign(...boardDefs.map(boardDef => ({ [boardDef.id]: boardDef })))

const boardDefsHandlerMapping = {
  [BOARD_DEFS_LOAD_SUCCESS]: boardDefsLoadSuccessReducer
}

const boardDefsInitialState = {}
export const boardDefsReducer = createReducer(boardDefsInitialState, boardDefsHandlerMapping)

export default boardDefsReducer



// WEBPACK FOOTER //
// ./src/store/boardDefs.js